import React from "react";

import { cn } from "../../lib/utils";

export const Field = ({
  title,
  renderTitle,
  renderValue,
  valueStyle,
  style,
  value,
}: {
  title?: string;
  renderTitle?: () => React.ReactNode;
  renderValue?: () => React.ReactNode;
  value?: string;
  style?: string;
  valueStyle?: string;
}) => (
  <div className={cn("flex flex-row min-w-0", style)}>
    {renderTitle ? renderTitle() : <FieldTitle>{title}</FieldTitle>}
    {renderValue ? (
      renderValue()
    ) : (
      <FieldValue className={valueStyle}>{value}</FieldValue>
    )}
  </div>
);

export const FieldValue = ({
  children,
  className,
  ...otherProps
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p
    className={cn(
      "flex-1 text-right text-sm leading-5 font-light whitespace-pre-line text-gray-800",
      className
    )}
    {...otherProps}
  >
    {children}
  </p>
);

export const FieldTitle = ({
  children,
  className,
  ...otherProps
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p
    className={cn(
      "flex-1 leading-4 tracking-wider text-sm font-light text-gray-600",
      className
    )}
    {...otherProps}
  >
    {children}
  </p>
);
